import {isValueEmail} from '@colonist/validation'
import {type AjaxDataTypes} from '../AjaxDataTypes.ts'

export class FeedbackFormDataValidate {
    static validate(data: AjaxDataTypes.FeedbackFormData): boolean {
        const {rate, email, feedback} = data
        if(rate != undefined) {
            if(rate < 1 || rate > 5) throw new Error(`Tried to save feedback with invalid rate. Rate must be between 1 and 5`)
        }

        if(email != undefined) {
            if(!isValueEmail(email)) throw new Error(`Tried to save feedback with invalid email`)
        }

        if(feedback != undefined) {
            if(feedback.length > 300) throw new Error(`Tried to save feedback with too many characters. Max is 300`)
        }
        return true
    }

    static isEmpty(data: AjaxDataTypes.FeedbackFormData): boolean {
        const {rate, email, feedback} = data
        return rate == undefined && email == undefined && feedback == undefined
    }
}
